import React, { Component } from 'react'

import { Player } from "video-react";

export default class About extends Component {
  render() {
    return (

      <section className="colorlib-about" data-section="about" style={{padding: "20px"}}>
          <div className="colorlib-narrow-content">
            
            <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <h3 style={{ marginLeft: "20px", color: "rgb(67, 197, 158)"}}>Education</h3>
              </div>
            </div>
            <div className="row row-pt-md">
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/udemy.png"
                  style={{ width: "220px", objectFit: "contain"}} />
              </div>
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/freecodecamp.png"
                  style={{ width: "220px", objectFit: "contain"}} />
              </div>
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/codecademy.jpg"
                  style={{ width: "220px", objectFit: "contain"}} />
              </div>
            </div>

            <div className="row row-pt-md">
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/youtube.jpg"
                  style={{ width: "220px", objectFit: "contain" }} />
              </div>
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/udacity.png"
                  style={{ width: "220px", objectFit: "contain", }} />
              </div>
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/skillshare.png"
                  style={{ width: "220px", objectFit: "contain"}} />
              </div>
            </div>
          </div>
        </section>


        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
            <div className="row">
              <div
                className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <h3 style={{ marginLeft: "20px", color: "rgb(67, 197, 158)" }}>Skills</h3>
              </div>
            </div>
            <div className="row row-pt-md">
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/react.png"
                  style={{ width: "200px", objectFit: "contain" }} />
              </div>
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/node.png"
                  style={{ width: "130px", objectFit: "contain", paddingTop: "20px" }} />
              </div>
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/firebase.png"
                  style={{ width: "100px", objectFit: "contain", paddingTop: "25px"}} />
              </div>
            </div>

            <div className="row row-pt-md">
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/material_ui.png"
                  style={{ width: "200px", objectFit: "contain" }} />
              </div>
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/mongodb.png"
                  style={{ width: "260px", objectFit: "contain", }} />
              </div>
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/bootstrap.jpg"
                  style={{ width: "220px", objectFit: "contain" }} />
              </div>
            </div>

            <div className="row row-pt-md">
              <div className="col-md-4 text-center animate-box">
                <img
                  src="images/wordpress.png"
                  style={{ width: "150px", objectFit: "contain" }} />
              </div>
            
            </div>
          </div>
        </section>
          </div>
      </section>
    );
  }
}
